import { render, staticRenderFns } from "./assetHeadManage.vue?vue&type=template&id=2b35767c&scoped=true&"
import script from "./assetHeadManage.vue?vue&type=script&lang=js&"
export * from "./assetHeadManage.vue?vue&type=script&lang=js&"
import style0 from "./assetHeadManage.vue?vue&type=style&index=0&id=2b35767c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35767c",
  null
  
)

export default component.exports